import axiosInstance from "../utils/axios";

export const createSubject = async (payload) => {
  try {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      "Content-Type": "multipart/form-data",
    };
    return await axiosInstance.post(`/api/create-subject`, payload, { headers });
  } catch (error) {
    throw error;
  }
};

export const getSubject = async (payload) => {
  try {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    };
    return await axiosInstance.get(`/api/subjects`, {
      headers,
      params: { ...payload },
    });
  } catch (error) {
    throw error;
  }
};

export const deleteSubject = async (subjectId) => {
  try {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    };
    return await axiosInstance.delete(`/api/subject/${subjectId}`, { headers });
  } catch (error) {
    throw error;
  }
};

export const updateSubject = async (payload, subjectId) => {
  try {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      "Content-Type": "multipart/form-data",
    };
    return await axiosInstance.put(
      `/api/update-subject/${subjectId}`,
      payload,
      { headers }
    );
  } catch (error) {
    throw error;
  }
};
